<template>
	<v-dialog
		:value="$wait.is('modal order')"
		scrollable
		persistent
		max-width="1200px"
		v-model="dialog"
	>
		<v-card>
			<v-card-title>
				<v-layout row wrap class="py-2 px-2">
					<v-flex xs12 md2 class="mt-5">
						<v-img
							src="/images/image_placeholder.jpg"
							width="150"
							height="150"
						></v-img>
					</v-flex>
					<v-flex xs12 md10>
						<v-card flat>
							<v-card-title class="px-0">
								Phov Thea
								<v-spacer></v-spacer>
								<v-btn color="error" outlined>
									{{ $t("label.reject_order") }}</v-btn
								>
							</v-card-title>
							<v-card-subtitle class="py-0 px-0"
								>+85587479956</v-card-subtitle
							>
						</v-card>
						<v-card-text class="py-0 px-0">
							<v-simple-table class="simple_table" dense>
								<thead>
									<tr>
										<th>{{ $t("label.order_number") }}</th>
										<th>
											{{ $t("label.order_date") }} &
											{{ $t("Time") }}
										</th>
										<th>{{ $t("Type") }}</th>
										<th>{{ $t("Amount") }}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>#0001</td>
										<td>20/10/2021 4:00pm</td>
										<td>
											<v-btn small color="primary"
												>Delivery</v-btn
											>
										</td>
										<td>$100</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-card-text>
					</v-flex>
				</v-layout>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap class="py-2 px-2">
					<v-flex xs12 md8>
						<div class="px-5">
							<v-list>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-subtitle
											><th>
												{{
													$t("label.delivery_address")
												}}
											</th></v-list-item-subtitle
										>

										<v-list-item-title
											>#6D, Borey Moha Sen Sok Phnom Penh,
											12411</v-list-item-title
										>
									</v-list-item-content>

									<v-list-item-action>
										3.6 km
									</v-list-item-action>
								</v-list-item>
							</v-list>
						</div>
						<v-divider></v-divider>
						<div class="py-5 px-5">
							<v-simple-table class="simple_table" dense>
								<thead>
									<tr>
										<th>{{ $t("label.ordered_item") }}</th>
										<th>&nbsp;</th>
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Paner Tikka Masaia</td>
										<td>X1 |</td>
										<td>$16</td>
									</tr>
									<tr>
										<td>Paner Tikka Masaia</td>
										<td>X1</td>
										<td>$16</td>
									</tr>
								</tbody>
							</v-simple-table>
						</div>
						<div class="px-5">
							<v-divider></v-divider>
							<v-list>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-subtitle>{{
											$t(
												"label.additional_information_form_customer"
											)
										}}</v-list-item-subtitle>

										<v-list-item-title
											>#6D, Borey Moha Sen Sok Phnom Penh,
											12411</v-list-item-title
										>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</div>
					</v-flex>
					<v-divider vertical></v-divider>
					<v-flex xs12 md4 class="py-2 px-5">
						<div class="mt-5">
							<header>{{ $t("label.other_details") }}</header>
							<v-simple-table class="simple_table" dense>
								<thead>
									<tr>
										<th>
											{{ $t("label.delivery_date") }}:
										</th>
										<th>Jan 11,2020</th>
									</tr>
									<tr>
										<th>{{ $t("label.delivery_time") }}</th>
										<th>8:45:00 pm</th>
									</tr>
								</thead>
							</v-simple-table>
						</div>
						<v-divider></v-divider>
						<div class="mt-5">
							<header>
								{{ $t("label.transaction_details") }}
							</header>
							<v-simple-table class="simple_table" dense>
								<thead>
									<tr>
										<th>{{ $t("label.sub_total") }}:</th>
										<th>100$</th>
									</tr>
									<tr>
										<th>{{ $t("label.delivery_fee") }}:</th>
										<th>8:45:00 pm</th>
									</tr>
									<tr>
										<th>{{ $t("label.total_amount") }}:</th>
										<th>8:45:00 pm</th>
									</tr>
								</thead>
							</v-simple-table>
						</div>
						<div class="mt-5">
							<v-btn color="purple" block dark>{{
								$t("label.accept_order")
							}}</v-btn>
						</div>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	data() {
		return {
			dialog: true,
		};
	},
};
</script>
<style scoped>
.simple_table table tr th {
	border-bottom: none !important;
}
</style>